
const ATTRIBUTE_IDS = Object.freeze({
    SECTOR: 64010032,
    CARD_LIMIT: 64010028,
    LEVEL: 64010030,
    TIME: 64010029,
    MANAGEMENT: 64010034
});

export default ATTRIBUTE_IDS;
